import { useEffect, useState } from 'react';
import { useParams, useNavigate  } from 'react-router-dom';
import { getBonusHistory } from '../../utils/api/api';
import './BonusHistoryPage.css'
import backIcon from '../../assets/back.png';

const BonusHistoryPage = () => {
    const navigate = useNavigate();
    const { sellerId, clientId } = useParams();
    const [history, setHistory] = useState([]);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null); // New state for error handling

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const data = await getBonusHistory(sellerId, clientId);
                if (data && data.length > 0) {
                    setHistory(data);
                } else {
                    setError('Нет данных для отображения');
                }
            } catch (fetchError) {
                void fetchError;
                setError('Что-то пошло не так, попробуйте позже');
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [sellerId, clientId]);

    const handleGoBack = () => {
        navigate(`/welcome/${sellerId}/${clientId}`);
    };

    const getValueStyle = (value) => {
        return value >= 0 ? { color: 'green' } : value < 0 ? { color: 'red' } : {};
    };

    const formatDate = (date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');

        return `${day}-${month}-${year}`;
    };

    const formatDateFire = (date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');

        return `${day}-${month}-${year}`;
    };

    const groupOperations = (historyItems) => {
        const grouped = [];
        let currentGroup = [];

        for (let i = 0; i < historyItems.length; i++) {
            const currentRecord = historyItems[i];
            const prevRecord = currentGroup[currentGroup.length - 1];

            const sameSign = (currentRecord.n_value >= 0 && prevRecord?.n_value >= 0) || (currentRecord.n_value < 0 && prevRecord?.n_value < 0);

            if (
                prevRecord &&
                prevRecord.f_check_heads === currentRecord.f_check_heads &&
                prevRecord.s_check === currentRecord.s_check &&
                sameSign &&
                Math.abs(new Date(currentRecord.d_date) - new Date(prevRecord.d_date)) < 60000
            ) {
                currentGroup.push(currentRecord);
            } else {
                if (currentGroup.length > 0) {
                    grouped.push(currentGroup);
                }
                currentGroup = [currentRecord];
            }
        }

        if (currentGroup.length > 0) {
            grouped.push(currentGroup);
        }

        const collapsedHistory = grouped.map(group => {
            const firstRecord = group[0];
            const summedValue = group.reduce((sum, record) => sum + parseFloat(record.n_value), 0);
            return { ...firstRecord, n_value: summedValue.toFixed(2), grouped: true };
        });

        return collapsedHistory;
    };

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = groupOperations(history).slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(groupOperations(history).length / recordsPerPage);

    const handleRecordsPerPageChange = (e) => {
        setRecordsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const nextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    if (loading) {
        return <div>Загрузка...</div>;
    }

    if (error) {
        return (
            <div className="modal">
                <div className="modal-content">
                    <p>{error}</p>
                    <button onClick={handleGoBack}>Назад на главную</button>
                </div>
            </div>
        );
    }

    return (
        <div className="welcome-container">
            <div className="back-button" onClick={handleGoBack}>
                <button className="back-button-style">
                    <img src={backIcon} alt="Back" className="back-icon" />
                </button>
            </div>
            <div className="records-per-page">
                <label htmlFor="recordsPerPage">Записей на странице: </label>
                <select
                    id="recordsPerPage"
                    value={recordsPerPage}
                    onChange={handleRecordsPerPageChange}
                >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                    <option value={50}>50</option>
                </select>
            </div>
            <div className="pagination">
                <button onClick={prevPage} disabled={currentPage === 1}>
                    Предыдущая
                </button>
                <span>{`Страница ${currentPage} из ${totalPages}`}</span>
                <button onClick={nextPage} disabled={currentPage === totalPages}>
                    Следующая
                </button>
            </div>
            <div className="history-table-container">
                <table className="history-table">
                    <thead>
                    <tr>
                        <th>Дата операции</th>
                        <th>Значение</th>
                        <th>Дата сгорания</th>
                        <th>Тип транзакции</th>
                    </tr>
                    </thead>
                    <tbody>
                    {currentRecords.map((item, index) => (
                        <tr key={index}>
                            <td>{formatDate(item.d_date)}</td>
                            <td style={getValueStyle(item.n_value)}>
                                {item.n_value === '.00' ? '0' : item.n_value}
                            </td>
                            <td>
                                {item.d_fire === "1900-01-01 00:00:00.000" ? " " : formatDateFire(item.d_fire)}
                            </td>
                            <td>{item.reason}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default BonusHistoryPage;